module.exports = __webpack_public_path__ + "static/media/logo-credito-carbono.8a14ea14.png";